import { useQuery } from "@apollo/client";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CupaPreferenceList } from "components/CupaPreferences/CupaPreferenceList";
import { GET_CUPA_PREFERENCE_PROFILE } from "hooks/useCupaPreferenceProfile";
import { useParams } from "react-router-dom";

export function CupaPlaybookPage() {
  const { cupaCode } = useParams<{ cupaCode: string }>();
  const { data, loading } = useQuery(GET_CUPA_PREFERENCE_PROFILE, {
    variables: { cupaCode: cupaCode ?? "" },
    skip: !cupaCode,
    fetchPolicy: "cache-and-network",
  });
  const profile = data?.cupaPreferenceProfile;

  return (
    <Stack spacing={2} sx={{ p: 3 }}>
      <Typography variant="h5">CUPA {cupaCode} — preferences</Typography>
      {loading && !profile && <Typography variant="body2">Loading…</Typography>}
      {!loading && !profile && (
        <Typography variant="body2" color="text.secondary">
          No preference profile yet for this CUPA.
        </Typography>
      )}
      {profile && (
        <Stack spacing={2}>
          {profile.summary && <Typography variant="body1">{profile.summary}</Typography>}
          <Typography variant="caption" color="text.secondary">
            Last analyzed {new Date(profile.createdAt).toLocaleString()} · {profile.model} ·{" "}
            {profile.sourceCount} source comments
          </Typography>
          <CupaPreferenceList preferences={profile.preferences} />
        </Stack>
      )}
    </Stack>
  );
}
